var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3728_4237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.57422 19.5C4.53516 16.9922 0 10.9141 0 7.5C0 3.35781 3.35781 0 7.5 0C11.6406 0 15 3.35781 15 7.5C15 10.9141 10.4297 16.9922 8.42578 19.5C7.94531 20.0977 7.05469 20.0977 6.57422 19.5ZM13.1016 9.97656C13.5391 8.94531 13.75 8.10938 13.75 7.5C13.75 4.04688 10.9531 1.25 7.5 1.25C4.04688 1.25 1.25 4.04688 1.25 7.5C1.25 8.10938 1.46211 8.94531 1.89688 9.97656C2.32305 10.9883 2.92188 12.0859 3.59922 13.1836C4.92969 15.3438 6.50781 17.4102 7.5 18.6562C8.49219 17.4102 10.0703 15.3438 11.4023 13.1836C12.0781 12.0859 12.6758 10.9883 13.1016 9.97656Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3728_4237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPerson);
export default __webpack_public_path__ + "static/media/inPerson.00b6eb1fa97e18465c25d53ac8ec30a6.svg";
export { ForwardRef as ReactComponent };